<template>
    <div>
        <section class="section-title-page container-fluid" style="background-image: url('/img/bg_tramite.jpg');">
            <div class="container">
                <div class="wrapper">
                    <h1>Pronunciamiento <small style="font-weight: 300;">destacado</small></h1>
                    <span>
                        Volver <i class="fa fa-angle-right mx-1"></i>
                        <a href="/">Inicio</a>
                    </span>
                </div>
            </div>
        </section>

        <section class="section-page bg-opac pt-3 container-fluid">
            <div class="container">
                <div class="row py-3">
                    <div class="col-md-8 pr-3 d-flex">
                        <div class="comun-pronun-selected">
                            <div class="title">
                                <h3>{{ Pronunciamiento.titulo }}</h3>
                            </div>
                            <div class="description px-3 py-0">
                               <!-- <div class="image" :style="{ 'background-image': 'url(' + Pronunciamiento.imagen + ')' }">
                                </div>-->
                                <div class="text px-0 py-0">
                                    <p class="date"><strong>Fecha de publicación: </strong>{{Pronunciamiento.fecha}}</p>
                                    <hr>
                                    <div class="info" v-html="Pronunciamiento.descripcion"></div>
                                </div>
                            </div>
                            <div class="image-main border mx-3 mb-3 rounded">
                                <img :src="Pronunciamiento.flayer" style="width: 100%;" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="section-right">
                            <div class="title-right">
                                <h3>ANTERIORES</h3>
                            </div>
                            <div class="search-right">
                                <input type="text" ref="miInput" name="search-right" class="form-control" placeholder="Buscar pronunciamiento">
                                <button @click="searchPronouncements"><i class="fa fa-search"></i></button>
                            </div>
                            <div class="box">
                                <div v-if="searchResults.length > 0">
                                    <div v-for="(value, key) in searchResults" :key="key" class="context">
                                        <a :href="'/pronunciamiento/' + value.id">
                                            <strong>{{ value.fecha }}</strong> - {{ value.titulo }}
                                        </a>
                                    </div>
                                </div>
                                <div v-else-if="searchQuery">
                                    <p class="text-white">No hay resultados</p>
                                </div>
                                <div v-else>
                                    <div v-for="(value, key) in ListaPronunciamientos.slice(0, 5)" :key="key" class="context">
                                        <a :href="'/pronunciamiento/' + value.id">
                                            <strong>{{ value.fecha }}</strong> - {{ value.titulo }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    name: 'pronunciamiento',
    computed: {
        ...mapState(['empresa']),
    },
    created() {
        this.getVerificar();
    },
    data() {
        return {
            id: this.$route.params.id || '-',
            ListaPronunciamientos: [],
            Pronunciamiento: {},
            searchQuery: "",
            searchResults: []
        }
    },
    watch: {
        '$route.params.id': function (newId) {
            this.id = newId;
            if (!newId) {
				this.$router.push({ name: '404' })
			} else {
				this.getVerificar()
			}
        }
    },
    methods: {
        ...mapMutations(['setLoading']),
        getVerificar() {
            this.setLoading(true);
            this.$http.get('ws_pronouncement/get_pronouncement?id=' + this.id).then((res) => {
                this.ListaPronunciamientos = res.data.Pronunciamientos;
                this.Pronunciamiento = res.data.Pronunciamiento;
            }).finally(() => {
                this.setLoading(false);
            });
        },
        searchPronouncements() {
            this.searchQuery =  this.$refs.miInput.value
            if (!this.searchQuery) {
                this.searchResults = [];
                return;
            }
            this.setLoading(true);
            this.$http.get(`ws_pronouncement/search_pronouncements?title=${this.searchQuery}`)
                .then((res) => {
                    this.searchResults = res.data.Pronunciamientos;
                })
                .catch((error) => {
                    console.error("Error searching pronouncements:", error);
                    this.searchResults = [];
                })
                .finally(() => {
                    this.setLoading(false);
                });
        }
    }
}
</script>
